import { useMsal } from "@azure/msal-react";
import { Avatar, IconButton, useTheme } from "@mui/material"
import { useEffect, useState } from "react";
import { httpGetBlobUrl } from "../../utils/http";
import PersonIcon from '@mui/icons-material/Person';
import { graphUrls } from "../shared/commonConstants";

interface LayoutTopAppBarAvatarProps {
    onClick: React.MouseEventHandler
}

export const LayoutTopAppBarAvatar = ({
    onClick
}: LayoutTopAppBarAvatarProps) => {

    const { accounts } = useMsal();
    const theme = useTheme();
    const [photoUrl, setPhotoUrl] = useState<string | null>(null);

    const setUserProfilePic = async () => {
        if (!photoUrl) {
            const responseUrl = await httpGetBlobUrl(graphUrls.photo);
            setPhotoUrl(responseUrl == '' ? null : responseUrl);
        }
    }

    useEffect(() => {
        // we want to set the profile pic
        // eslint-disable-next-line
        setUserProfilePic();
        // we want to restrict only accounts
        // eslint-disable-next-line
    }, [accounts])

    return (
        <IconButton id="menu-icon" onClick={onClick} sx={{ p: 0, "& :hover": { opacity: 0.8 } }}>
            {photoUrl &&
                <Avatar src={photoUrl} sx={{
                    border: `2px solid ${theme.palette.grey[500]}`,
                    height: '42px', width: '42px'
                }} />
            }
            {!photoUrl &&
                <PersonIcon
                    sx={{
                        color: theme.palette.common.white,
                        fontSize: 28
                    }}
                />
            }
        </IconButton>
    )
}
